/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for creating a new remote MCP server
 */
export type CreateServerForm = {
  /**
   * Optional human-readable name for the remote MCP server. Empty values are stored as null.
   */
  name?: string | undefined;
  /**
   * The transport type for the remote MCP server (e.g. streamable-http)
   */
  transportType: string;
  /**
   * The URL of the remote MCP server
   */
  url: string;
  /**
   * For createServerAndMcpServer, the ID of an existing project- or organization-owned user session issuer to attach to the linked MCP server. Omit to mint a project issuer. The source-only createServer method rejects this field.
   */
  userSessionIssuerId?: string | undefined;
};

/** @internal */
export type CreateServerForm$Outbound = {
  name?: string | undefined;
  transport_type: string;
  url: string;
  user_session_issuer_id?: string | undefined;
};

/** @internal */
export const CreateServerForm$outboundSchema: z.ZodMiniType<
  CreateServerForm$Outbound,
  CreateServerForm
> = z.pipe(
  z.object({
    name: z.optional(z.string()),
    transportType: z.string(),
    url: z.string(),
    userSessionIssuerId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      transportType: "transport_type",
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function createServerFormToJSON(
  createServerForm: CreateServerForm,
): string {
  return JSON.stringify(
    CreateServerForm$outboundSchema.parse(createServerForm),
  );
}
